import React from "react";
import classNames from "classnames/bind";
import { motion, AnimatePresence } from "framer-motion";

// assets
import { FilterIcon, GpsIcon } from "src/assets/icons";

import styles from "./Header.module.scss";
const cx = classNames.bind(styles);

const Header = ({ isOpen }) => {
  return (
    <div className={cx("mob-header-root")}>
      <AnimatePresence exitBeforeEnter>
        {
          !isOpen ? (
            <motion.div
              key="main"
              initial={{ opacity: 0, y: -100 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -100 }}
              transition={{ duration: 0.35 }}
              className={cx("main-content")}
            >
              <span className={cx("icon-wrapper")}>
                <FilterIcon />
              </span>
              <span className={cx("title")}>Today's Event</span>
              <span className={cx("icon-wrapper")}>
                <GpsIcon />
              </span>
            </motion.div>
          ) : null
          // <motion.div
          //   key="close"
          //   initial={{ opacity: 0 }}
          //   animate={{ opacity: 1 }}
          //   exit={{ opacity: 0 }}
          //   transition={{ duration: 0.35 }}
          //   className={cx("close-btn-wrapper")}
          // >
          //   <span className={cx("icon-wrapper")} onClick={handleClose}>
          //     <CloseIcon />
          //   </span>
          // </motion.div>
        }
      </AnimatePresence>
    </div>
  );
};

export default Header;
